import { Button, CircularProgress, Typography } from '@mui/material';

export const PrimaryButton = (props = {}) => {
  const { sx, children, disabled, onClick, ...otherProps } = props;

  return (
    <Button
      variant="contained"
      onClick={(e) => {
        if (onClick) {
          if (props.loadingLogic) {
            onClick(e);
          } else {
            onClick(e);
          }
        }
      }}
      {...otherProps}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '18px',
        gap: '10px',
        position: 'relative',
        width: '100%',
        height: '57px',
        minHeight: '57px',
        borderRadius: '56px',
        backgroundColor: disabled ? '#D9D9D9' : '#44546A',
        boxShadow: 'none',
        ...(disabled || props.isLoading ? { pointerEvents: 'none' } : {}),
        '&.MuiButtonBase-root:hover': {
          bgcolor: '#536680',
          boxShadow: 'none',
        },
        border: 'none',

        textTransform: 'normal',
        ...props.sx,
      }}
      style={{ textTransform: 'none', ...props.style }}
    >
      <Typography
        variant="button"
        sx={{
          color: '#FFFFFF',
          fontWeight: '700',
          fontSize: '14px',
          textTransform: 'normal',
          whiteSpace: 'nowrap',
        }}
      >
        {props.isLoading ? (
          <CircularProgress
            color="inherit"
            size={'25px'}
            sx={{
              position: 'absolute',
              margin: 'auto',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            }}
          />
        ) : (
          <>{props.children}</>
        )}
      </Typography>
    </Button>
  );
};

export default PrimaryButton;
